import React from 'react';
import Checkbox from "./Checkbox";
import {t} from "../components/Translate";
import Tooltip from "./Tooltip";

const CheckboxWithTooltip = ({tooltip, checked, setChecked}) => {

    const handleCheckboxChange = () => {
        setChecked();
    };

    return (
        <Tooltip text={tooltip}>
            <div style={{width: '20px'}}>
                <div
                    style={{
                        width: '20px'
                    }}
                >
                    <Checkbox
                        type="checkbox"
                        checked={checked}
                        onChange={handleCheckboxChange}
                    />
                </div>
            </div>
        </Tooltip>
    );
};

export default CheckboxWithTooltip;



// WEBPACK FOOTER //
// ./src/components-new/CheckboxWithTooltip.jsx